module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "photo50"
  }, [_c('h1', {
    staticClass: "part-number---IVP",
    attrs: {
      "id": "sigil_toc_id_1",
      "title": "Part One: Bottom"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('h2', {
    staticClass: "part-title---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("BOTTOM")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "dingbat",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/4324_graphic_TP1.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page10",
      "title": "10"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669203ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part1.vue
// module id = 66
// module chunks = 0